import { useIssueTypesAndFields } from '@atlassian/jira-business-entity-project/src/services/issue-types-and-fields/index.tsx';
import type { BusinessSelectOption } from '@atlassian/jira-business-entity-project/src/services/issue-types-and-fields/types.tsx';

export type CellOptionType = {
	label?: string;
	value: string;
	optionId?: string | number;
};
export const useCellOptions = ({ fieldId }: { fieldId: string }) => {
	const {
		data: { fields },
	} = useIssueTypesAndFields({
		issueOperation: 'VIEW',
	});

	const fieldConfigOptions =
		fields.filter((f) => f.id === fieldId)?.[0]?.fieldConfig?.selectOptions ?? [];

	const getLatestFieldValue = (fieldValue?: CellOptionType | CellOptionType[] | null) => {
		const optionMap: Record<string, string> = {};
		fieldConfigOptions?.forEach((field) => {
			const { value, optionId } = field;
			optionMap[String(optionId)] = value;
		});

		let updated = false;
		const updatedFieldValue: BusinessSelectOption[] = [];

		const fieldValueArray = Array.isArray(fieldValue) ? fieldValue : [fieldValue];

		fieldValueArray?.forEach((field) => {
			if (field) {
				const { optionId, value } = field;
				const strOptionId = String(optionId);
				if (value !== optionMap[strOptionId]) updated = true;
				updatedFieldValue.push({
					optionId,
					value: optionMap[strOptionId] ?? value,
					label: optionMap[strOptionId] ?? value,
				});
			}
		});

		if (!Array.isArray(fieldValue)) {
			return updated ? updatedFieldValue[0] : fieldValue;
		}

		return updated ? updatedFieldValue : fieldValue;
	};

	return {
		latestFieldOptions: fieldConfigOptions || [],
		getLatestFieldValue,
	};
};
